import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';

const NEAR_BOTTOM_PX = 40;

export default function useStickToBottom(itemCount, extraDep = null) {
  const containerRef = useRef(null);
  const pinnedRef = useRef(true);
  const prevCountRef = useRef(itemCount);
  const [isPinned, setIsPinned] = useState(true);
  const [newCount, setNewCount] = useState(0);

  const handleScroll = useCallback(() => {
    const el = containerRef.current;
    if (!el) return;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= NEAR_BOTTOM_PX;
    pinnedRef.current = atBottom;
    setIsPinned(atBottom);
    if (atBottom) setNewCount(0);
  }, []);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;
    el.addEventListener('scroll', handleScroll, { passive: true });
    return () => el.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useLayoutEffect(() => {
    const el = containerRef.current;
    const appended = Math.max(0, itemCount - prevCountRef.current);
    prevCountRef.current = itemCount;
    if (!el) return;
    if (pinnedRef.current) {
      el.scrollTop = el.scrollHeight;
    } else if (appended > 0) {
      setNewCount((c) => c + appended);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemCount, extraDep]);

  const jumpToLatest = useCallback(() => {
    const el = containerRef.current;
    if (el) el.scrollTop = el.scrollHeight;
    pinnedRef.current = true;
    setIsPinned(true);
    setNewCount(0);
  }, []);

  return { containerRef, isPinned, newCount, jumpToLatest };
}
